import axios from "axios";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import DeleteIcon from "@mui/icons-material/Delete";

function Adminfeepaid() {
  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;
  const [data, setdata] = useState([]);

  useEffect(() => {
    getFeePaid();
  }, []);

  const getFeePaid = async () => {
    try {
      const res = await axios.get("/api/admin/getfeepaid");
      if (res.status === 200) {
        setdata(res.data.success || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteFee = async (id) => {
    if (window.confirm("Delete this fee entry?")) {
      try {
        await axios.delete(`/api/admin/deletefee/${id}`);
        alert("Deleted successfully");
        getFeePaid();
      } catch (err) {
        alert("Failed to delete");
      }
    }
  };

  const columns = [
    { dataField: "studentName", text: "Student Name" },
    { dataField: "standard",    text: "Standard" },
    { dataField: "month",       text: "Month" },
    { dataField: "totalAmount", text: "Total (₹)" },
    { dataField: "paidAmount",  text: "Paid (₹)" },
    { dataField: "paidDate",    text: "Paid Date" },
    { dataField: "paymentMethod", text: "Payment Method" },
    { dataField: "remarks",     text: "Remarks" },
    {
      dataField: "",
      text: "Delete",
      formatter: (cell, row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => deleteFee(row._id)}
        >
          <DeleteIcon fontSize="small" />
        </button>
      ),
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total px-4">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "5",   value: 5 },
      { text: "10",  value: 10 },
      { text: "All", value: data.length },
    ],
  };

  return (
    <div style={{ background: "#fff" }}>
      <h2 style={{ color: "#01a695", textAlign: "center" }}>Fee Paid</h2>

      <ToolkitProvider
        keyField="_id"
        data={data}
        columns={columns}
        search
        exportCSV={{ fileName: "fee_paid.csv", blobType: "text/csv;charset=ansi" }}
      >
        {(props) => (
          <div>
            <span className="px-3 mr-auto">
              <ExportCSVButton className="btn-outline-success" {...props.csvProps}>
                Export to Excel
              </ExportCSVButton>
            </span>
            <span className="pl-4 mr-5 mt-5">
              <SearchBar className="form-control" {...props.searchProps} />
            </span>
            <ClearSearchButton className="btn-outline-info" {...props.searchProps} />
            <hr />
            <div className="table-responsive" style={{ margin: "30px" }}>
              <BootstrapTable
                keyField="_id"
                striped
                hover
                condensed
                columns={columns}
                data={data}
                pagination={paginationFactory(options)}
                {...props.baseProps}
              />
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Adminfeepaid;
